import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RxFormGroup } from '@rxweb/reactive-form-validators';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
	providedIn: 'root'
})
export class LayoutsService {

	baseUrl = `${environment.apis.base}/layouts`;

	constructor(private readonly http: HttpClient) { }

	datatable(page?: number, options?: any): Observable<Object> {
		let httpParams = new HttpParams();

		if (typeof page === 'number') {
			httpParams = httpParams.append('page', page);
		}

		if ('key' in options && options.key.trim() !== '') {
			httpParams = httpParams.append('search', options.key);
		}

		return this.http.get<any>(this.baseUrl, {params: httpParams});
	}

	show(id: number): Promise<any> {
		const url = `${this.baseUrl}/${id}`;

		return this.http.get<any>(url).toPromise();
	}

	getAll(): Promise<any> {
		const url = `${this.baseUrl}`;

		return this.http.get<any>(url).toPromise();
	}

	getLayoutsByGroupId(id: number): Promise<any> {
		const url = `${this.baseUrl}/getLayoutByGroupId/${id}`;

		return this.http.get<any>(url).toPromise();
	}

	createOrUpdate(data: RxFormGroup, id?: number): Observable<Object> {
		let url = this.baseUrl;

		if (id) {
			url += `/${id}`;
			return this.http.put<any>(url, data.value);
		} else {
			return this.http.post<any>(url, data.value);
		}

	}

	delete(id: number): Observable<Object> {
		const url = `${this.baseUrl}/${id}`;

		return this.http.delete<any>(url);
	}
}
